import { reduxForm, reset } from 'redux-form'
import moment from 'moment'

import QuickMessageForm from '../../components/messages/quick-create-message-form'

import { createMessageForWorkOrder } from '../../actions/messages'

const fields = [
  'body',
  'timezone'
]

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      return dispatch(createMessageForWorkOrder(ownProps.workOrderId, data))
        .then(() => dispatch(reset('quickCreateWorkOrderMessage')))
    }
  }
}

export default reduxForm(
  {
    fields,
    initialValues: {
      timezone: moment.tz.guess()
    },
    form: 'quickCreateWorkOrderMessage'
  },
  null,
  mapDispatchToProps
)(QuickMessageForm)



// WEBPACK FOOTER //
// ./src/containers/messages/quick-create-message-container.js